import Cookies from "js-cookie";
import React from "react";
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";

const COWORK_ONLY_PATHS = ["/", "/mybookings", "/allroombookings", "/allrooms", "/usermanagement"];

export const PrivateRoute = () => {
  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page
  let token = Cookies.get("token");
  const location = useLocation();

  const hostname = window.location.hostname;
  const isMakersLabHost = hostname.includes("makerslab.mastersunion.org") || hostname.includes("localhost");

  const rolesCookie = Cookies.get("roles");
  const rolesArray = rolesCookie ? JSON.parse(rolesCookie) : [];
  const isStudent = rolesArray.includes("Cowork Student") || rolesArray.includes("Cowork Lab Student");

  // if (token && isMakersLabHost && isStudent && COWORK_ONLY_PATHS.includes(location.pathname)) {
  //   return <Navigate to="/classroom-available-rooms" replace />;
  // }

  return token ? <Outlet /> : <Navigate to="/login" />;
};
